import {v4 as uuidv4} from 'uuid';

const portfolioOneData = [ 
    {
        id: uuidv4(),
        img: `/img/projects/EMDAD.jpg`,
        name:'UPGRADING OF EMDAD PUMPING FACILITY AND ASSOCIATED WORKS AT JEBEL ALI',
        contract_value: '2,550,000',
        client: 'EMDAD',
        main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Extension of equipment room - pipe supports - electric cable trench from the substation to filter pump- microcin filter foundation-chipping and grouting of existing pump foundation filter water separator shed - duct bank.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/prism.jpg`,
        name:'Shed work',
        // contract_value: '2,550,000',
        client: 'Prism Engineering ',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Design, Fabrication and Installation of Sandwich Panel Shed as per Dubai Municipality Requirement'
    },
    {
        id: uuidv4(),
        img: `/img/projects/Kitchen.jpg`,
        name:'Kitchen renovation work',
        // contract_value: '2,550,000',
        client: 'Capricorn Bakery ',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Tile installation, Kitchen hood installation, Aluminium doors, Partition works, and Full MEP services'
    },
    {
        id: uuidv4(),
        img: `/img/projects/Stair.jpg`,
        name:'LTS technical services',
        // contract_value: '2,550,000',
        client: 'Staircase tile installation work (B1+B2+G+9)',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Supply and installation of staircase tiles for B1+B2+G+9 floors.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/interior.jpg`,
        name:'Interior work',
        // contract_value: '2,550,000',
        client: 'Clove Beauty',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'3d Drawings, Approvals, Glass sticker installation, Blinds installation, Interior decoration'
    },
    {
        id: uuidv4(),
        img: `/img/projects/Ecf.jpg`,
        name:'Warehouse ceiling light installation',
        // contract_value: '2,550,000',
        client: 'ECF',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Supply and installation of 120 lights for warehouse ceiling.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/BeautySalon.jpg`,
        name:'Caramel Bath n Body Interior work',
        // contract_value: '2,550,000',
        client: 'Sadeco',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Gypsum partition installation, MDF backing in the wall, Internal painting, Ceiling painting, Tile installation'
    },
    {
        id: uuidv4(),
        img: `/img/projects/fbm.jpg`,
        name:'RT bunker construction',
        // contract_value: '2,550,000',
        client: 'FBM Hudszon',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'RT bunker construction including Civil works, Lead Shielding, Blockwork, Plastering, and Finishing as per Authority and Safety Requirements'
    },
    {
        id: uuidv4(),
        img: `/img/projects/Bentley.jpg`,
        name:'Bentley showroom glass work',
        // contract_value: '2,550,000',
        client: 'Al habtoors',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Supply and installation of glass for Bentley showroom.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/GAC.jpg`,
        name:'GAC ware house renovation',
        // contract_value: '2,550,000',
        client: 'Ibex international',
        // main_contractor:'Fortune Energy and Engineering Solutions',
               // date: 'Dubai',
        index: '06',
        scope:'Warehouse internal painting, Compound wall construction, Warehouse light installation and Tile installation'
    },
    {
        id: uuidv4(),
        img: '/img/projects/Oil.jpg',
        contract_value: '2.4 million',
        name: 'Oil Well Middle East',
        // date: 'Fujairah',
        scope:'Designing, Obtaining Construction Approval from Free-Zone Authority, Construction of the Admin Building, Fire water pump house and fire water tank, as per the Design drawings, including Supply and Installation of Electrical and HVAC Equipment, Fire-Fighting and sewage system, water supply system and allied works. '
    },

    {
        id: uuidv4(), 
        img: '/img/projects/EMARAT.jpg',
        contract_value: '390,000',
        name: 'EMARAT',
        // date: 'Dubai',
        scope:'Dismantling of Existing Carousel Filling Machine, Evacuation Unit, Pneumatic Control Panel and Existing Cabling. Installation of New 12 Scale LPG Carousel Filling Machine, Evacuation Unit, Pneumatic Control Panel, Admission & Ejection Unit including laying and modifications to power and process lines.3" Class 300 LPG Piping Modification works in Truck Loading Gantries 1 and 2. Roto Gauge Installation and Tank Calibration of 150MT Horizontal Bullet Propane Tank (Tank -5).'
    },

    {
        id: uuidv4(),
        img: '/img/projects/MELUBCO.jpg',
        contract_value: '101,255',
        name: 'MELUBCO',
        main_contractor:'B.K Fabrication and Services F.Z.E',
      //  date: 'Dubai',
        scope:'Concrete demolition inside tank MBT2, Concrete demolition and reinstating of tank berm, Removal of existing layers of soil, and PVC pipe inside tank and disposal, Supply and laying new uPVC leak detection pipe up-to tank boundary. Supply and laying layers of dune, road base and bitumen sand.'
    },
    {
        id: uuidv4(),
        img: '/img/projects/Magnum.jpg',
        contract_value: '988,000',
        name: 'Magnum Technology center',
     //   date: 'Dubai',
        index: '02',
        scope:'Grading, leveling, laying interlock over road base, laying kerb-stone and fencing works for an area 15,000 m2.'
    },
    {
        id: uuidv4(),
        img: '/img/projects/YARD.jpg',
        name:'YARD DEVELOPMENT ACTIVITIES AT HAMRIYAH FREEZONE',
        contract_value: '1.04 Million',
        client: 'Magnum Technology Center',
     //   date: 'Dubai',
        index: '03',
        scope:'Vegetation Removal, Road Base Levelling, Supply and Paving of Interlock in 15,000m2 Area, Kerbstone paving for 450 RM, Fabrication and Installation of Chain Link Fencing and Access Gate for 450 RM.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/TAMAM.jpg`,
        name:'CONSTRUCTION OF WAREHOUSE AT AL QOUZ',
        contract_value: '2,600,000',
         client: 'TAMAM BUILDING EXHIBITION LLC',
      //  date: 'Dubai',
        index: '07',
        scope:'Construction of warehouse including bloc walls, partitions, structural steelwork, and electrical cabling works'
    },
    // {
    //     id: uuidv4(),
    //     img: `https://www.poweron.ae/assets/uploads/project/construction-of-civil-foundation-at-dusup-plant-margham.jpg`,
    //     name:'UPGRADING OF EMDAD PUMPING FACILITY AND ASSOCIATED WORKS AT JEBEL ALI',
    //     contract_value: '2,550,000',
    //      client: 'EMDAD',
    //      main_contractor:'Fortune Energy and Engineering Solutions',
    //   //  date: 'Dubai',
    //     index: '08',
    //     scope:'Extension of equipment room - pipe supports - electric cable trench from the substation to filter pump- microcin filter foundation-chipping and grouting of existing pump foundation filter water separator shed - duct bank.'
    // },
    // {
    //     id: uuidv4(),
    //     img: `https://www.poweron.ae/assets/uploads/project/refurbishment-of-drainage-and-sanitary-system.jpg`,
    //     name:'CONSTRUCTION OF WAREHOUSE AT AL QOUZ',
    //     contract_value: '2,600,000',
    //     client: 'TAMAM BUILDING EXHIBITION LLC',
    //   //  date: 'Dubai',
    //     index: '09',
    //     scope:'Construction of warehouse including bloc walls, partitions, structural steelwork, and electrical cabling works'
    // },
    {
        id: uuidv4(),
        img: `/img/projects/PETROSTEM.jpg`,
        name:'CIVIL AND ELECTRICAL MAINTENANCE WORK IN PETROSTEM FACTORY',
        contract_value: '456,000',
        client: 'PETROSTEM',
       // date: 'Dubai',
        index: '10',
        scope:''
    },
    // {
    //     id: uuidv4(),
    //     img: `https://www.poweron.ae/assets/uploads/project/dubal-corner-risk-improvement-project-for-dusup.jpg`,
    //     name:'CIVIL AND ELECTRICAL MAINTENANCE WORK IN PETROSTEM FACTORY',
    //     contract_value: '456,000',
    //      client: 'PETROSTEM',
    //    // date: 'Dubai',
    //     index: '11',
    //     scope:''
    // },
    {
        id: uuidv4(),
        img: `/img/projects/AUDEX.jpg`,
       // name:'',
        contract_value: '507,500',
        name:'AUDEX FUJAIRAH LL FZE',
       // client: 'M/S Dubai Supply Authority',
       // date: 'Dubai',
        index: '12',
        scope:'Pipe sleepers, Foam Skid shelter, IBC Container foundation and shelter, equipment foundations, and Cross over Platform.'
    },
    
    {
        id: uuidv4(),
        img: `/img/projects/LAMPRELL.jpg`,
       // name:'',
        contract_value: '2.46 million',
        name:'   LAMPRELL ENERGY LIMITED',
        // client: 'PETROSTEM',
       // date: 'Dubai',
        index: '13',
        scope:'Civil Works includes RCC pipe supports and RCC foundation, Impact wall, Pig Launcher/ receiver pads, RCC Containment pits, RCC boundary wall 200 RM, Epoxy protective coating to RCC wall, access road 6m wide, 200RM, light poles foundations and solar light panels, Earthing grid system, Chain link fence, etc.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/EMICOOL.jpg`,
        contract_value: '245,487',
        name:'PACT Engineering',
        client: 'EMICOOL LLC.',
       // date: 'Dubai',
        index: '14',
        scope:'Panel water tanks and piping works for water treatment unit, Construction of foundations for tanks and container skid.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/HAMRIYAH.jpg`,
        name:'PROJECT: DEVELOPMENT OF YARD AREA AT HAMRIYAH FREE ZONE 2',
        contract_value: '507,000',
        client: 'OIL WELL MIDDLE EAST',
       // date: 'Dubai',
        index: '15',
        scope:'Development of open fabrication yard which includes leveling and graveling in yard area, boundary fence, and interlock paving, light pole foundations and cabling works, etc. at Hamriyah free zone-2.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/SHERATON.jpg`,
        name:'ACCESS ROAD DECORATIVE WORKS AT SHERATON HOTEL MALL OF THE EMIRATES',
        contract_value: '650,000',
        main_contractor:'Enova (Subsidiary of Majid Al Futtaim)',
         client: 'SHERATON HOTEL',
       // date: 'Dubai',
        index: '16',
        scope:'Stone Paving, Interlock Laying, RCC Slab, Granite laying, and landscaping, etc.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/MASAFI.jpg`,
        name:'CONSTRUCTION OF TISSUE FACTORY SHED EXTENSION',
        contract_value: '2.1 million',
        client: 'MASAFI WATER CO. MASAFI, FUJAIRAH',
       // date: 'Dubai',
        index: '17',
        scope:'Civil foundation works & extension of structural works for the shed 100mx10m, including  foundation, flooring, supply & erection of roof structure, sandwich panel roofing, covered car parking, etc., and various maintenance jobs.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/ERHARDT.jpg`,
        name:'NEW WAREHOUSE FOR ERHARDT AND PARTNER AT DUBAI WORLD CENTRAL',
        contract_value: '1.1 Million',
        client: 'ERHARDT AND PARTNER  , DUBAI WORLD CENTRE',
       // date: 'Dubai',
        index: '18',
        scope:'Interior works including Partition and ceiling, covered car park, sanitary and plumbing works, floor tiling works, etc.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/SIMBA.jpg`,
        name:'INTERIOR WORKS OF OFFICE AND COVERED CAR PARKS AT JAFZA SOUTH',
        contract_value: '703,000',
         client: 'SIMBA TOYS MIDDLE EAST',
       // date: 'Dubai',
        index: '19',
        scope:'Gypsum partition & ceiling works, covered car park 21 parking, pump room, wooden floor & canopy, floor tiles, and floor carpets, interlock yard paving (20,000m2), paneled water tank and plumbing works, Pump room wiring and DB connections.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/SSANGYONG.jpg`,
        name:'GYPSUM PARTITION WORK AT ICD BROOKFIELD PLACE',
        contract_value: '451,000',
        client: 'MULTIPLEX SSANGYONG',
       // date: 'Dubai',
        index: '20',
        scope:''
    },
    {
        id: uuidv4(),
        img: `/img/projects/RANI.jpg`,
        name:'RENOVATION OF LABOUR CAMP',
        contract_value: '1.4 Million',
        client: 'RANI INTERNATIONAL DUBAI',
       // date: 'Dubai',
        index: '21',
        scope:'Renovation of labor camp- maintenance for staff accommodations- Blockwork, plastering and painting, floor, tiles, water supply, and sanitary works, etc.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/FIRE.jpg`,
        name:'FIRE PUMP ROOM MODIFICATION',
        contract_value: '820,000',
         client: 'MALL OF THE EMIRATES, DUBAI',
       // date: 'Dubai',
        index: '22',
        scope:'Construction of Fire Pump room, access ramp, pump foundations, epoxy floor coating, etc.'
    },
    {
        id: uuidv4(),
        img: `/img/projects/EMIRATES.jpg`,
        name:'REFURBISHMENT OF DRAINAGE AND SANITARY SYSTEM, EMIRATES ATRIUM BUILDING.',
        contract_value: '1.25 Million',
        client: 'EMIRATES PETROLEUM LTD, DUBAI',
       // date: 'Dubai',
        index: '23',
        scope:'Refurbishment of drainage and replacement of the sanitary system of Emirate Atrium Building'
    },
    {
        id: uuidv4(),
        img: `/img/projects/SUEZ.jpg`,
        name:'M/S SUEZ, ABU DHABI',
        contract_value: '800,000',
       // client: 'M/S Dubai Supply Authority',
       // date: 'Dubai',
        index: '24',
        scope:'Equipment Foundations, concrete protection works, RCC paving & Kerbstone laying,etc., at Margham gas plant.'
    },

]

export default portfolioOneData;